import { useLocation, useNavigate } from "react-router-dom";

export default function withRouter(Component) {
    function ComponentRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        return (
            <Component
                {...props}
                location={location}
                navigate={navigate}
            />
        );
    }
    return ComponentRouterProp;
}